// getFilterType.js
'use strict';
import { matchPath } from 'react-router';

import { FEATURE_LIVESTREAM_FEED_FILTER_TYPE } from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';
import { removeLangFromPath } from '../resource/langPath.js';

import getRouterData from '../selector/getRouterData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select filter type by base remote config key name and pathname
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} pathname - pathname.
 * @return {string} Return filter type.
 */
const getFilterType = createCachedSelector(
  state => getRemoteConfigData(state, FEATURE_LIVESTREAM_FEED_FILTER_TYPE),
  state => getRouterData(state, 'location.pathname'),
  (filterType = 'v1', pathname = '') => {
    const V2_VALID_ROUTES = ['/following', '/livestream'];
    const cleanPathname = removeLangFromPath(pathname);
    return filterType === 'v2' &&
      V2_VALID_ROUTES.some(route => matchPath(route, cleanPathname))
      ? 'v2'
      : 'v1';
  }
)(() => 'getFilterType');

export default getFilterType;
